// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

::ng-deep app-root cds-loading-overlay.shell-overlay cds-overlay .cds-overlay {
  z-index: 2 !important;
  position: relative;
  height: calc(100vh - 4rem);
}

.visibility-hidden {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,0BAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n::ng-deep app-root cds-loading-overlay.shell-overlay cds-overlay .cds-overlay {\n  z-index: 2 !important;\n  position: relative;\n  height: calc(100vh - 4rem);\n}\n\n.visibility-hidden {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
